const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const fetchLeads = async (page = 1, filters = {}, itemsPerPage = 8, role) => {
    const token = localStorage.getItem('token');

    if (!token) {
        console.error('[fetchLeads] Ошибка: Токен авторизации не найден.');
    }

    let queryParams = `page=${page}&per_page=${itemsPerPage}`;

    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== '') {
            if (key === 'sortOrder') {
                queryParams += `&order_by=${encodeURIComponent(filters[key])}`;
            } else if (Array.isArray(filters[key])) {
                filters[key].forEach(value => {
                    queryParams += `&${encodeURIComponent(key)}[]=${encodeURIComponent(value)}`;
                });
            } else {
                queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`;
            }
        }
    }

    try {
        const response = await fetch(`${API_BASE_URL}/${role}/lead/leads?${queryParams}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();

            console.error('[fetchLeads] Ошибка загрузки лидов:', errorData);
            throw { ...errorData, statusCode: response.status };
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('[fetchLeads] Ошибка сети или другая ошибка при загрузке лидов:', error);
        throw error;
    }
};

